import type { SVGProps } from "react";
export interface CallSignalIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CallSignalIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CallSignalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.395 1.067A3.194 3.194 0 0 1 9.343 2.64l1.094 2.189a3.19 3.19 0 0 1-.599 3.685l-1.012 1.01c.5 1.152 1.314 2.314 2.325 3.325 1.01 1.01 2.172 1.822 3.322 2.323l1.012-1.01a3.19 3.19 0 0 1 3.686-.599l2.188 1.095a3.193 3.193 0 0 1 1.573 3.946l-.892 2.45c-.492 1.354-1.864 2.266-3.363 2.037-4.9-.75-8.98-2.698-12.025-5.744S1.66 10.224.91 5.324c-.229-1.499.681-2.873 2.035-3.365zm1.935 2.58a.943.943 0 0 0-1.166-.465l-2.45.89c-.417.152-.636.546-.58.91.688 4.501 2.452 8.117 5.109 10.774s6.273 4.422 10.774 5.11c.364.055.758-.162.91-.579l.89-2.452a.943.943 0 0 0-.464-1.166l-2.189-1.093a.94.94 0 0 0-1.088.176l-1.53 1.53a1.13 1.13 0 0 1-1.152.273c-1.75-.583-3.446-1.728-4.834-3.116s-2.53-3.083-3.114-4.834c-.135-.404-.03-.85.27-1.15l1.531-1.532a.94.94 0 0 0 .178-1.088z"
      />
      <path
        fill={color}
        d="M16.874 10a2.875 2.875 0 0 0-2.58-2.86l-.41-.02A1.125 1.125 0 0 1 14 4.875l.264.006A5.125 5.125 0 0 1 19.124 10a1.125 1.125 0 1 1-2.25 0m4 0a6.875 6.875 0 0 0-6.52-6.866L14 3.125l-.115-.006A1.125 1.125 0 0 1 14 .875l.47.012a9.125 9.125 0 0 1 8.655 9.112 1.125 1.125 0 0 1-2.25 0Zm-5.5 0a1.375 1.375 0 0 1-2.742.14l-.007-.14.007-.141A1.375 1.375 0 0 1 14 8.625l.141.008c.693.07 1.233.655 1.233 1.366Z"
      />
    </svg>
  );
}
